export const AnagramOpenEventName = 'anagram:open'

export type AnagramOpenEventDetail = {
  placementId: string
}

/**
 * Dispatch the merchant-facing open event on a target window (the host page, or a
 * same-origin preview iframe). Mirrors the snippet merchants paste into their sites.
 */
export function dispatchAnagramOpen(target: Window, placementId: string): void {
  target.dispatchEvent(new CustomEvent<AnagramOpenEventDetail>(AnagramOpenEventName, {detail: {placementId}}))
}
